/* eslint-disable import/first */
import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import { Divider, Typography } from '@material-ui/core';
import { Context } from '../../components/Multi-lang/Wrapper';
const { selectAllMain } = Slices.categorySlice;
const { selectDesktop, isCartFetched } = Slices.appSlice;
import CartBar from '../../components/CartBar';
import CartItemList from '../../components/CartItemList';
import UpsellList from '../../components/UpsellList';
import AddressWidget from '../../components/AddressWidget';
const { selectFirstMenu } = Slices.menuSlice;
const { selectCountryValidations, selectOrderModesByCountry } = Slices.configSlice;
const { removeApply } = Slices.offerSlice;
const {
  sendCart,
  cartAmount,
  cartItems,
  getGoGreenConfig,
  selectCartPromoCode,
  selectCartDiscountCode,
  selectCartPromoType,
  selectCouponApplied,
  selectFreeCategory,
  selectDescFail,
} = Slices.cartSlice;
const { selectCurrentCountry, selectCartId } = Slices.profileSlice;
import EmptyCart from './EmptyCart';

import CookingInstructions from './CookingInstructions';
import GoGreen from './GoGreen';
import ExploreMenu from './ExploreMenu';
import CouponBox from './CouponBox';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';

import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import 'react-loading-skeleton/dist/skeleton.css';
import CartSkelton from './CartSkelton';
import Loader from '../../components/Loader';

import { applyCouponFailureGA, exploreMenuGA } from 'spwa-ui-library/esm/utils/helperGA';
const { selectLoginStatus } = Slices.authSlice;
const { removeItemCart, selectCartStatus } = Slices.cartSlice;
const { selectDefaultAddress, addressStatus } = Slices.addressSlice;
const { getClusterId } = Slices.configSlice;
import ReviewCartPopUp from './ReviewCartPopUp';
import CartValues from './CartValues';
import css from './index.module.scss';
import ClassNames from 'classnames';
import AmtAlertPopUp from './AmtAlertPopUp';
import FreeItemSelection from './freeItemSelection';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

function PHCart({ foodInstr, handleFoodInstr }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const locationSearch = new URLSearchParams(location.search);
  const menu = useSelector(selectFirstMenu);

  const cartStatus = useSelector(selectCartStatus);
  const goGreenConfig = useSelector((state) => state.cart.goGreen);
  const offer = useSelector((state) => state.offer);
  const address = useSelector(selectDefaultAddress);
  const statusAddress = useSelector(addressStatus);
  const freeCatId = useSelector(selectFreeCategory);
  const isFetched = useSelector(isCartFetched);
  const promoCode = useSelector(selectCartPromoCode);
  const promoCodeType = useSelector(selectCartPromoType);
  const iscouponApplied = useSelector(selectCouponApplied);
  const discountItemFail = useSelector(selectDescFail);
  const discountCode = useSelector(selectCartDiscountCode);
  const country = useSelector(selectCurrentCountry);
  const config = useSelector((state) => state.config);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const cartId = useSelector(selectCartId);
  const itemsInTheCart = useSelector(cartItems);
  const cartItemList = useSelector(cartItems);
  const auth = useSelector((state) => state.auth);
  const [applyLoader, setApplyLoader] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  const [sugguestedAmount, setSugguestedAmount] = useState(0);

  const [validate, setValidate] = React.useState(false);
  const [couponStatus, setCouponStatus] = React.useState('initial');
  const [status, setStatus] = React.useState('initial');
  const [edit, setEdit] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [selectFreeItem, setSelectFreeItem] = React.useState(false);
  const [selectDiscountedItem, setSelectDiscountedItem] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState('');
  const [offerDisable, setOfferDisable] = useState(null);
  const categories = useSelector(selectAllMain);
  const user = useSelector(selectLoginStatus);
  const clusterId = useSelector(getClusterId);
  const checkCartId = useSelector(selectCartId);
  const context = useContext(Context);
  const [exploreLink, setExploreLink] = useState(null);
  const [amtAlert, setAmtAlert] = useState(false);
  const isDesktop = useSelector(selectDesktop);
  const [reviewCart, setReviewCart] = React.useState(false);
  const [reviewPopUp, setReviewPopUp] = React.useState(false);
  const [cartReview, setCartReview] = React.useState(false);
  const cartAmountList = useSelector(cartAmount);
  const [discountList, setDiscountList] = React.useState({});
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const countOfItems = cartItemList.reduce((a, { qty }) => a + qty, 0);
  const findDefaultMode = orderModes.find((mode) => mode.default === true);
  // let redirect = '/addAddress';
  let urlPathToMode = '';
  if (isDesktop && findDefaultMode) {
    if (auth.guestLogin) {
      urlPathToMode = `/cart/?modal=addaddress`;
    } else {
      urlPathToMode = `/cart/?modal=${findDefaultMode.type.toLowerCase()}`;
    }
  } else if (!isDesktop && findDefaultMode) {
    urlPathToMode = `/${findDefaultMode.type.toLowerCase()}`;
  } else {
    urlPathToMode = `/addAddress`;
  }
  // console.log(findDefaultMode, 'order');
  let redirect = urlPathToMode;
  const couponCode = offer.apply ? offer.apply.couponCode : '';
  let addressType = 'DELIVERY';
  let addressSubType = 'DELIVERY';
  if (Object.entries(address).length) {
    redirect = '/guest';
    addressType = address.addressType;
    addressSubType = address.addressSubType;
  }
  if (offer.apply && status === 'initial') {
    setStatus('loaded');
    setApplyLoader((prev) => false);
    //setCouponStatus('removed');
  }

  useEffect(() => {
    // let items = cartItemList;
    if (isFetched) {
      let codeVal = promoCode || couponCode || discountCode;
      const addressToken = window.localStorage.getItem('_add');
      const addressDetail = JSON.parse(addressToken);
      if (addressDetail?.addressSubType) {
        addressSubType = addressDetail.addressSubType;
        addressType = addressDetail.addressType;
      }
      const payload = {
        body: {
          addressSubType: addressSubType,
          addressType: addressType,
          addressId: address?.id || '',
          cartId: cartId,
          applySurprisePromo: codeVal?.length > 0,
          clusterId: clusterId || '',
          items: itemsInTheCart,
          version: 'v20',
          orderType: addressType,
          storeId: address?.storeId,
        },
        headers: { country },
      };
      const restrictSend = window.localStorage.getItem('menuUpdate') || 'false';
      if (
        itemsInTheCart.length &&
        cartId &&
        !locationSearch.has('cartId') &&
        restrictSend !== 'true'
      ) {
        dispatch(sendCart(payload)).then((res) => {
          setTimeout(() => {
            setPageLoader(false);
          }, 1000);

          if (res.error) {
            console.error(res.error);
          }
        });
      } else {
        setPageLoader(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched]);
  useEffect(() => {
    let freeItem = checkIfFreeItemAdded();
    if (freeItem.isExist && iscouponApplied === 0) {
      dispatch(removeItemCart({ id: freeItem.index }));
      refreshCart(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iscouponApplied, countOfItems]);
  const removeCoupon = (e) => {
    let freeItem = checkIfFreeItemAdded();
    let discountedItem = checkIfDiscountedItemAdded();
    if (freeItem.isExist) {
      dispatch(removeItemCart({ id: freeItem.index }));
    }
    if (promoCodeType === 'discountItem' && discountedItem.isExist) {
      dispatch(removeItemCart({ id: discountedItem.index }));
    }
    setApplyLoader((prev) => true);
    applyCouponFailureGA(couponCode, user);
    dispatch(removeApply());

    setCouponStatus('removed');
    setDiscountList({});
    if (discountCode) {
      refreshCart(true, true);
    }
  };
  // GO GREEN FIXES
  useEffect(() => {
    if (config.status == 'succeeded') {
      // GO GREEN CONFIG
      let ids =
        cartItemList && cartItemList[0]?.parentId ? cartItemList[0]?.parentId : cartItemList[0]?.id;
      if (ids) {
        dispatch(
          getGoGreenConfig({ menuId: countryValidations?.defaultMenuId, productIds: [ids] })
        );
      }
    }
  }, [cartItemList, config.status, countryValidations.defaultMenuId, dispatch]);

  useEffect(() => {
    status === 'initial' && setApplyLoader((prev) => false);
  }, [status]);

  const refreshCart = React.useCallback(
    (flagToCheck, isRemoveDiscountCoupon, removeDiscountedItems) => {
      setPageLoader((pre) => true);
      let items = cartItemList;

      let codeVal = flagToCheck ? promoCode : couponCode || '';
      if (discountCode && !isRemoveDiscountCoupon) {
        codeVal = discountCode;
      }
      codeVal = codeVal || promoCode || ''; // TODO: Coupon getting lost on refresh

      if (removeDiscountedItems) {
        items = cartItemList.filter((element) => !element?.isDiscounted);
      }
      if (flagToCheck && isRemoveDiscountCoupon) {
        codeVal = '';
      }
      const payload = {
        body: {
          addressSubType: addressSubType,
          addressType: addressType,
          addressId: address?.id || '',
          cartId: cartId,
          applySurprisePromo: false,
          clusterId: clusterId || '',
          items: items,
          version: 'v20',
          orderType: addressType,
          storeId: address?.storeId,
        },
        headers: { country },
      };

      const restrictSend = window.localStorage.getItem('menuUpdate') || 'false';
      if (cartId && !locationSearch.has('cartId') && restrictSend !== 'true') {
        dispatch(sendCart(payload)).then((res) => {
          setTimeout(() => {
            setPageLoader(false);
          }, 1000);

          if (res?.payload?.data?.data?.couponApplied === 1) {
            // applyCouponSuccessGA(couponCode, user);
          } else {
            setApplyLoader(false);
            // applyCouponFailureGA(couponCode, user);
          }
          if (res.error) {
            setOpen(true);
            setApplyLoader(false);
            setErrMsg(res.error.message);
          }
        });
      } else {
        setPageLoader(false);
        setApplyLoader(false);
      }

      setCouponStatus('applied');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [address.id, addressSubType, addressType, cartItemList, cartId, country, couponCode, dispatch]
  );

  const checkIfFreeItemAdded = () => {
    let isExist = false;
    let index;
    // const items = cartItemList?.map((item) => item.id);
    cartItemList.forEach((itm, idx) => {
      let catId = +freeCatId;
      if (!catId) {
        catId = +offer?.apply?.freeCategories;
      }

      if (itm.catId === catId) {
        isExist = true;
        index = itm.id;
      }
    });

    return { index, isExist };
  };

  const checkIfDiscountedItemAdded = () => {
    const itemsCatId = cartItemList?.map((item) => item.catId);
    const itemIndex = itemsCatId.indexOf(freeCatId);
    return { index: itemIndex, isExist: itemIndex > -1 };
  };

  //TODO: transfer to free category
  useEffect(() => {
    if (freeCatId && iscouponApplied === 0 && !checkIfFreeItemAdded().isExist && !pageLoader) {
      setSelectFreeItem(true);
    } else {
      setSelectFreeItem(false);
    }
    if (discountCode && discountItemFail === 1) {
      setSelectDiscountedItem(true);
    } else {
      setSelectDiscountedItem(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartStatus, pageLoader]);

  useEffect(() => {
    if ((cartStatus === 'idle' && cartId) || couponStatus === 'removed') {
      // const loadType = window.performance.getEntriesByType('navigation')[0].type;
      // if (loadType !== 'reload') {
      // }
      refreshCart(false);
    }
    // if (cart.status === 'succeeded') {
    const min = countryValidations?.minOrderAmount;
    const amount = cartAmountList?.length ? cartAmountList?.[0]?.amount : 0;
    const discountExist = cartAmountList?.filter((each) => each.type === 'DISCOUNT');
    const shippingAmount = cartAmountList?.filter((each) => each.type === 'SHIPPING');
    const discount = (discountExist.length && discountExist[0].amount) || 0;
    const calculateAmount = amount - discount;
    if (calculateAmount && calculateAmount < min && !discount) {
      if (addressType === 'DELIVERY') {
        setValidate(true);
        setSugguestedAmount(0);
      } else {
        setValidate(false);
      }
    } else {
      if (discount && addressType === 'DELIVERY') {
        // 32-10=22
        //suggest 23+7.5
        const val = amount - discount;
        if (val >= min) {
          setSugguestedAmount(0);
          setValidate((prev) => false);
        } else {
          // const difference = min - val;
          setSugguestedAmount(min + shippingAmount[0]?.amount);

          setValidate(true);
        }
      } else {
        setSugguestedAmount(0);
        setValidate((prev) => false);
      }
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartStatus, couponStatus, cartAmountList?.length]);

  useEffect(() => {
    if (
      // cart.fetchState === true &&
      cartStatus !== 'loading' &&
      cartStatus !== 'idle' &&
      statusAddress !== 'idle' &&
      !cartReview
    ) {
      // debugger;
      const restrictSend = window.localStorage.getItem('menuUpdate') || 'false';
      if (restrictSend !== 'true') {
        refreshCart(false);
        setCartReview((prev) => true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartStatus]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    const result = categories.length > 0 && categories?.sort((a, b) => a.position - b.position);
    const exploreMenuPath = `/${context?.locale}/${URLEncode(result?.[0]?.name)}/${
      result?.[0]?.id
    }`;
    setExploreLink(exploreMenuPath);
  }, [categories, context.locale, exploreLink]);

  const handleCart = () => {
    setEdit(!edit);
  };

  useEffect(() => {
    const list = cartAmountList.find((each) => each.type === 'DISCOUNT');
    if (list) {
      setDiscountList(list);
    } else {
      setDiscountList({});
    }
  }, [cartAmountList, couponStatus]);

  const exploreMenuClick = (exploreLink) => {
    navigate(exploreLink);
    exploreMenuGA();
  };

  const editButton = !isDesktop && cartItemList.length > 0 && (
    <Button variant="outlined" size="small" className={css.editBtn} onClick={handleCart}>
      {edit ? (
        <FormattedMessage id="trackorder_done" defaultMessage="Done" />
      ) : (
        <FormattedMessage id="customizeEdit" defaultMessage="Edit" />
      )}
    </Button>
  );

  const vatPercentage = countryValidations?.constants?.cartAmount?.find(
    (each) => each.name === 'TAX'
  );

  const handleFreeItemClose = () => {
    removeCoupon();
  };

  const titleCart = () => {
    return (
      <>
        {intl.formatMessage({ id: 'cart' })}{' '}
        {countOfItems > 0 && (
          <span>
            ( {' ' + countOfItems}{' '}
            {intl.formatMessage({
              id: 'item',
            })}{' '}
            )
          </span>
        )}
      </>
    );
  };
  let freeItemList = [];
  cartItemList.forEach((itemVal) => {
    if (itemVal.freeItem) {
      freeItemList.push(itemVal);
    }
  });
  return (
    <>
      {!checkCartId ? (
        <CartSkelton />
      ) : (
        <>
          {pageLoader && <Loader shadow />}
          {selectFreeItem ? (
            <FreeItemSelection
              freeCatId={freeCatId}
              isOpen={selectFreeItem || selectDiscountedItem}
              isDiscountedItem={selectDiscountedItem}
              isFreeItem={selectFreeItem}
              onClose={handleFreeItemClose}
            />
          ) : (
            ''
          )}
          <div className={css.root}>
            <Header title={titleCart()} actionButtons={[<LanguageButton />, editButton]} />

            <Snackbar
              open={open}
              autoHideDuration={6000}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                {errMsg}
              </Alert>
            </Snackbar>
            {cartItemList.length ? (
              <>
                <div className={css.widgets}>
                  <div className={css.firstWidgetContainer}>
                    {/* cart info */}
                    <div className={ClassNames(css.firstWidget, css.row1)}>
                      {isDesktop && (
                        <div className={css.cartHeading}>
                          <div className={css.carth}>
                            <span className={css.cartTitle}>
                              <FormattedMessage id="cart_title1" defaultMessage="Items" />{' '}
                            </span>
                            <FormattedMessage id="cart_title2" values={{ count: countOfItems }} />
                          </div>
                        </div>
                      )}
                      <div className={ClassNames(css.cartItemsList, css.widget)}>
                        <CartItemList
                          freeItems={freeItemList || []}
                          editMode={edit}
                          itemList={cartItemList}
                          handleCart={handleCart}
                          setReviewCart={setReviewCart}
                          setCartReview={setReviewPopUp}
                          setErrMsg={setErrMsg}
                        />

                        <CookingInstructions
                          title={countryValidations?.specialCookingTitle}
                          placeholder={countryValidations?.specialCookingInstrPlaceholder}
                          note={countryValidations?.specialCookingInstrNote}
                          foodInstr={foodInstr}
                          handleFoodInstr={handleFoodInstr}
                        />
                      </div>
                    </div>
                    {/* go green */}
                    {goGreenConfig?.GO_GREEN_WIDGET_ENABLE === 1 && (
                      <div className={ClassNames(css.firstWidget, css.row2)}>
                        <GoGreen config={goGreenConfig} className={css.widget} />
                      </div>
                    )}
                    {/* upsell */}
                    <div className={ClassNames(css.firstWidget, css.row3)}>
                      <UpsellList />
                    </div>
                  </div>
                  <div className={css.secondWidget}>
                    {!isDesktop && (
                      <ExploreMenu
                        className={css.widget}
                        onClick={() => exploreMenuClick(exploreLink)}
                      />
                    )}
                    {isDesktop && (
                      <div className={css.sideHeading}>
                        <div className={css.sideTitle}>
                          <FormattedMessage
                            id="orderstatus_ordersummary"
                            defaultMessage="Order Summery"
                          />
                        </div>
                        <Divider />
                      </div>
                    )}
                    <div className={css.desktopWrapper}>
                      {isDesktop && <AddressWidget urlPathToMode={urlPathToMode} />}
                      {/* {cart?.data?.couponApplied && offer?.apply ? ( */}
                      <CouponBox
                        refreshCart={refreshCart}
                        setOfferDisable={setOfferDisable}
                        onRemove={removeCoupon}
                        selectFreeItem={selectFreeItem}
                        pageLoader={pageLoader}
                      />
                      <div className={css.section}>
                        <CartValues
                          amountObj={cartAmountList}
                          currency={countryValidations.currency}
                        />
                        {countryValidations?.isVatEnabled && (
                          <Typography className={css.taxTypo}>
                            <FormattedMessage
                              id={'inclusive_VAT'}
                              values={{
                                vat_percent: vatPercentage?.value,
                                vat_amount: decimalChecker(
                                  (cartAmountList?.find((amt) => amt.code == 'TOTAL')?.amount ||
                                    0) * 0.05
                                ),
                                currency: countryValidations?.currency,
                              }}
                            />
                          </Typography>
                        )}
                      </div>
                    </div>
                    {validate && isDesktop && (
                      <div className={css.alertError}>
                        <p>
                          {sugguestedAmount ? (
                            <FormattedMessage
                              id="alertErrorTotal"
                              defaultMessage="Total must be "
                            />
                          ) : (
                            <FormattedMessage
                              id="alertErrorSubTotal"
                              defaultMessage="Sub Total must be "
                            />
                          )}
                          <span>
                            {sugguestedAmount !== 0
                              ? sugguestedAmount
                              : countryValidations?.minOrderAmount}{' '}
                            {countryValidations?.currency || ''}
                          </span>
                          <FormattedMessage
                            id="alertError2"
                            defaultMessage=" in order to proceed with this order"
                          />
                        </p>
                      </div>
                    )}
                    {amtAlert && (
                      <AmtAlertPopUp
                        setAmtAlert={setAmtAlert}
                        sugguestedAmount={sugguestedAmount}
                        countryValidations={countryValidations}
                        menu={menu}
                        amountObj={cartAmountList}
                        isDesktop={isDesktop}
                        defaultPath={exploreLink}
                      />
                    )}
                    {isDesktop && (
                      <CartBar
                        reviewCart={reviewCart}
                        reviewPopUp={reviewPopUp}
                        setReviewPopUp={setReviewPopUp}
                        amtAlert={amtAlert}
                        setAmtAlert={setAmtAlert}
                        validate={validate}
                        miniCart={true}
                        hideImg={true}
                        buttonText={<FormattedMessage id="checkout" defaultMessage="Checkout" />}
                        to={auth.guestLogin ? redirect : '/checkout'}
                      />
                    )}
                  </div>
                </div>

                {/* {countryValidations?.minOrderAmount > cartAmountList?.[0].amount &&*/}
                {validate && !isDesktop ? (
                  <div className={css.alertError}>
                    <p>
                      {sugguestedAmount ? (
                        <FormattedMessage id="alertErrorTotal" defaultMessage="Total must be " />
                      ) : (
                        <FormattedMessage
                          id="alertErrorSubTotal"
                          defaultMessage="Sub Total must be "
                        />
                      )}
                      <span>
                        {sugguestedAmount !== 0
                          ? sugguestedAmount
                          : countryValidations?.minOrderAmount}{' '}
                        {countryValidations.currency || ''}
                      </span>
                      <FormattedMessage
                        id="alertError2"
                        defaultMessage=" in order to proceed with this order"
                      />
                    </p>
                  </div>
                ) : (
                  ''
                )}
              </>
            ) : (
              <>
                {cartStatus === 'succeeded' || auth.guestLogin ? (
                  <EmptyCart defaultPath={exploreLink} />
                ) : (
                  ''
                )}
              </>
            )}
            <footer className={css.footer}></footer>
            {reviewPopUp && (
              <ReviewCartPopUp
                errorMsg={errMsg}
                reviewCart={reviewCart}
                setReviewPopUp={setReviewPopUp}
                isDesktop={isDesktop}
              />
            )}
          </div>
          {!isDesktop && (
            <CartBar
              reviewCart={reviewCart}
              reviewPopUp={reviewPopUp}
              setReviewPopUp={setReviewPopUp}
              setAmtAlert={setAmtAlert}
              validate={validate}
              hideImg={true}
              buttonText={<FormattedMessage id="cart_placeorder" defaultMessage="Place Order" />}
              to={auth.guestLogin ? redirect : '/checkout'}
            />
          )}
        </>
      )}
    </>
  );
}

export default PHCart;
